// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__zauTC","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1vWBi"};